import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/whatsapp"
  }, React.createElement("path", {
    id: "WhatsApp 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04372 4.55567C5.90798 4.23061 5.80506 4.21825 5.59944 4.20994C5.52944 4.20589 5.45145 4.20184 5.36494 4.20184C5.09741 4.20184 4.81773 4.28005 4.64897 4.45286C4.44334 4.66275 3.93311 5.15242 3.93311 6.15648C3.93311 7.16066 4.66537 8.1318 4.76414 8.26775C4.86706 8.40337 6.19181 10.494 8.24883 11.346C9.85741 12.0126 10.3347 11.9508 10.7008 11.8727C11.2356 11.7576 11.9062 11.3623 12.075 10.8851C12.2436 10.4077 12.2436 10.0002 12.1942 9.91384C12.1449 9.82744 12.009 9.77822 11.8034 9.67519C11.5978 9.57227 10.598 9.07844 10.4088 9.01259C10.2236 8.9427 10.0467 8.96742 9.90695 9.16495C9.70942 9.44069 9.51616 9.72058 9.35975 9.88923C9.23637 10.0209 9.03469 10.0374 8.86603 9.96744C8.63973 9.87294 8.00623 9.65047 7.22453 8.95506C6.61969 8.41606 6.20833 7.74537 6.08911 7.54369C5.96978 7.33795 6.07675 7.21852 6.17136 7.1075C6.27428 6.97986 6.37294 6.88941 6.47575 6.76997C6.57867 6.65064 6.6362 6.58895 6.70205 6.44895C6.77205 6.31322 6.72261 6.17322 6.67328 6.0703C6.62384 5.96716 6.21248 4.96298 6.04372 4.55567ZM7.99792 1C4.13895 1 1 4.13983 1 7.99989C1 9.5307 1.49372 10.9505 2.33295 12.1028L1.46069 14.7036L4.15131 13.8437C5.25797 14.5762 6.57856 15 8.00208 15C11.861 15 15 11.86 15 8.00011C15 4.14005 11.861 1.00022 8.00208 1.00022L7.99792 1Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Whatsapp16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Whatsapp16 = createIcon(IconComponent);